import { useCallback, useRef } from 'react';

const MAX_HEIGHT = 120;

export const useAutosizeTextarea = () => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const resize = useCallback(() => {
    const textarea = textareaRef.current;

    if (!textarea) {
      return;
    }

    textarea.style.height = '0px';

    const height = Math.min(textarea.scrollHeight, MAX_HEIGHT);

    textarea.style.height = `${height}px`;

    textarea.style.overflowY =
      textarea.scrollHeight > MAX_HEIGHT ? 'auto' : 'hidden';
  }, []);

  // Callback-ref: сохраняет узел и сразу подгоняет высоту при монтировании —
  // нужно, чтобы восстановленный многострочный черновик открывался нужной высоты
  // (без useEffect). Стабилен (deps: resize) — React вызывает его только на
  // маунт/анмаунт, а не на каждый рендер.
  const setTextareaRef = useCallback(
    (node: HTMLTextAreaElement | null) => {
      textareaRef.current = node;

      if (node) {
        resize();
      }
    },
    [resize]
  );

  return {
    textareaRef,
    setTextareaRef,
    resize,
  };
};
